export default __webpack_public_path__ + "static/media/Seccion_promos_pasada_04_Septiembre.1438b198.webp";